import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import { Form } from "react-final-form";
import OtpInput from "react-otp-input";
import {
    UiCol,
    UiSingleRow,
} from "../../../_uiComponents/grid-container/GridContainer";
import { UiCheckbox } from "../../../_uiMocks/components/form/UiInput";
import { UiButtonPrimary } from "../../../_uiMocks/components/form/UiButton";
import Validator from "../../../../_helpers/validate.schema";
import {
    loginAuthRequest,
    forgotPasswordResetPasswordRequest,
    preRegistrationActivateRequest,
    hideAjaxSuccess,
    reSendOtpRequest,
} from "../../../../_redux/_actions";
import { otpTypeConstants, authConstants } from "../../../../_redux/_constants";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { Context } from "../../../../_context/Store";


const validateSchema = () =>
    yup.object().shape({
        otp: yup
            .string()
            .required("Otp is required.")
            .min(1, "Otp is required.")
            .min(6, "Six charactors are required."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function OtpVerification(props) {
    const [otp, setOtp] = useState("");
    const [remember, setRemember] = useState(false);
    const [seconds, setSeconds] = useState(30);
    const [state, dispatch] = useContext(Context);

    useEffect(() => {
        if (seconds > 0) {
            const timerId = setTimeout(() => {
                setSeconds(seconds - 1);
            }, 1000);

            // Cleanup the timeout on component unmount
            return () => clearTimeout(timerId);
        }
    }, [seconds]);

    const { id, userId } = useParams();

    const actionDispatch = useDispatch();
    const navigate = useNavigate();

    const { userProfileDetails } = useSelector((state) => {
        return {
            userProfileDetails: state.auth.userProfileDetails,
        };
    });

    useEffect(() => {
        if (id == otpTypeConstants.AUTH_TYPE_LOGIN) {
            if (typeof userProfileDetails.email == "undefined") {
                navigate("/");
            }
        }

        if (id == otpTypeConstants.AUTH_TYPE_FOGOT_PASSWORD) {
            if (typeof userProfileDetails.authToken == "undefined") {
                navigate("/");
            }
        }

        if (id == otpTypeConstants.AUTH_TYPE_ACCOUNT_ACTIVATION) {
            if (typeof userProfileDetails.activationCode == "undefined") {
                navigate("/");
            }
        }
    }, []);

    const submit = async (values) => {
        if (id == otpTypeConstants.AUTH_TYPE_LOGIN) {
            const browserFingerprint = await getFingerPrint();
            actionDispatch(
                loginAuthRequest({
                    email: userProfileDetails.email,
                    password: userProfileDetails.password,
                    browserFingerprint,
                    validateOtp: true,
                    otp: values.otp,
                    rememberBrowser: remember,
                    navigate: navigate,
                    requetedUrl : state.requetedUrl
                }),
            );
        }

        if (id == otpTypeConstants.AUTH_TYPE_FOGOT_PASSWORD) {
            actionDispatch(
                forgotPasswordResetPasswordRequest({
                    authToken: userProfileDetails.authToken,
                    confirmPassword: userProfileDetails.confirmPassword,
                    newPassword: userProfileDetails.newPassword,
                    userId: userProfileDetails.userId,
                    otp: values.otp,
                    validateOtp: true,
                    navigate,
                }),
            );
        }

        if (id == otpTypeConstants.AUTH_TYPE_ACCOUNT_ACTIVATION) {
            actionDispatch(
                preRegistrationActivateRequest({
                    userId: userId,
                    firstName: userProfileDetails.firstName,
                    lastName: userProfileDetails.lastName,
                    password: userProfileDetails.password,
                    activationCode: userProfileDetails.activationCode,
                    validateOtp: true,
                    otp: values.otp,
                    navigate,
                }),
            );
        }
    };

    const resendOtp = async () => {
        const browserFingerprint = await getFingerPrint();

        actionDispatch(
            reSendOtpRequest({
                userId: userId,
                otpTypeId: id,
                rememberBrowser: false,
                browserFingerprint,
            }),
        );
    };

    return (
        <>
            <Form
                onSubmit={submit}
                validate={onValidate}
                mutators={{
                    setFormAttribute: (
                        [fieldName, fieldVal],
                        state,
                        { changeValue },
                    ) => {
                        changeValue(state, fieldName, () => fieldVal);
                    },
                }}
                render={({
                    form,
                    handleSubmit,
                    hasValidationErrors,
                    ...formValues
                }) => {
                    return (
                        <form onSubmit={validateSchema}>
                            <div className="sb-otp-input-wr">
                                <OtpInput
                                    value={otp}
                                    inputType="number"
                                    autoFocus
                                    onChange={(e) => {
                                        setOtp(e);

                                        form.mutators.setFormAttribute(
                                            "otp",
                                            e,
                                        );
                                    }}
                                    numInputs={6}
                                    maxLength={1}
                                    renderSeparator={<span> </span>}
                                    renderInput={(props) => (
                                        <input
                                            {...props}
                                            className="sb-otp-input"
                                        />
                                    )}
                                />
                            </div>

                            {id == otpTypeConstants.AUTH_TYPE_LOGIN && (
                                <div className="sb-otp-checkbox">
                                    <UiCheckbox
                                        checked={remember}
                                        label="Remember this device for 30 days"
                                        onClick={(e) => {
                                            setRemember(!remember);
                                        }}
                                    />
                                </div>
                            )}
                            <p className="sba-form-error">{}</p>
                            {form.getState().submitFailed &&
                                formValues.errors.otp && (
                                    <p className="sba-form-error">
                                        {formValues.errors.otp}
                                    </p>
                                )}
                            <UiSingleRow className="sb-top-resend-wr">
                                <UiCol
                                    lg="4"
                                    xs="12"
                                    className="sb-otp-resend-label"
                                >
                                    <span
                                        style={
                                            seconds == 0
                                                ? {}
                                                : {
                                                      pointerEvents: "none",
                                                      color: "#c6c7c9",
                                                  }
                                        }
                                        onClick={() => {
                                            if (seconds == 0) {
                                                setSeconds(30);
                                                resendOtp();
                                            }
                                        }}
                                    >
                                        Resend OTP{" "}
                                    </span>
                                    <div className="sb-otp-timer">
                                        ({seconds})
                                    </div>
                                </UiCol>
                                <UiCol lg="8" xs="12">
                                    <div className="sb-otp-btns">
                                        <UiButtonPrimary
                                            btnName="Cancel"
                                            onClick={() => {
                                                actionDispatch(
                                                    hideAjaxSuccess(),
                                                );
                                                navigate("/");
                                            }}
                                        />
                                        <div className="sb-otp-btns__verify">
                                            <UiButtonPrimary
                                                btnName="Verify"
                                                onClick={handleSubmit}
                                            />
                                        </div>
                                    </div>
                                </UiCol>
                            </UiSingleRow>
                        </form>
                    );
                }}
            />
        </>
    );
}
